import { Record as record, List, Map as map } from 'immutable';

import { construct, resolveAll, fields } from '../helpers/LinkMapper';
import DiscountRule from './DiscountRule';
import { SeasonStages, PointStages, DaySaveStages } from '../constants/AppConstants';


const defaults = {
    id: null,
    allowAdult: null,
    allowChild: null,
    allowRailcard: null,
    brandId: null,
    description: null,
    name: null,
    discountCode: null,
    oneOffPromoCode: null,
    percent: null,
    promotionUrl: null,
    purchaseFrom: null,
    purchaseTo: null,
    travelFrom: null,
    travelTo: null,
    discountRules: new List(),
    redirectTab: null,
    maxProducts: null
};

const searchStages = map({
    point: PointStages.SEARCH,
    season: SeasonStages.SEARCH,
    daySave: DaySaveStages.SEARCH
});

class Discount extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(Discount, json, {
            id: fields.string,
            allowAdult: fields.boolean,
            allowChild: fields.boolean,
            allowRailcard: fields.boolean,
            brandId: fields.string,
            description: fields.string,
            name: fields.string,
            discountCode: fields.string,
            oneOffPromoCode: fields.boolean,
            percent: fields.number,
            promotionUrl: fields.string,
            purchaseFrom: fields.datetime,
            purchaseTo: fields.datetime,
            travelFrom: fields.datetime,
            travelTo: fields.datetime,
            discountRules: resolveAll.as(DiscountRule),
            redirectTab: fields.string,
            maxProducts: fields.number
        });
    }

    get searchStage() {
        return searchStages.get(this.redirectTab, searchStages.get('season'));
    }
}

export default Discount;



// WEBPACK FOOTER //
// ./src/records/Discount.js